import { Box, Input, SimpleGrid, Text } from "@chakra-ui/react";
import { FilterChip } from "../../FilterChip";

export function StepPeople({ presets, answers, setAnswers }) {
  function selectPreset(value) {
    setAnswers((prev) => ({ ...prev, people: value, peopleMode: "preset" }));
  }

  function handleCustomChange(e) {
    const raw = e.target.value.replace(/\D/g, "");
    const value = raw ? parseInt(raw, 10) : null;
    setAnswers((prev) => ({ ...prev, people: value, peopleMode: "custom" }));
  }

  return (
    <Box>
      <Text fontSize={{ base: "17px", md: "20px" }} fontWeight="900" color="#004a33" mb="3px">
        Quantas pessoas vão beber no seu evento?
      </Text>
      <Text fontSize="12px" color="gray.500" mb="12px">
        Não se preocupe em calcular nada — a Boozen resolve isso pra você.
      </Text>

      <SimpleGrid columns={{ base: 4, sm: 5, md: 6 }} spacing="6px" mb="10px">
        {presets.map((p) => (
          <FilterChip
            key={p}
            label={String(p)}
            isActive={answers.peopleMode === "preset" && answers.people === p}
            onClick={() => selectPreset(p)}
          />
        ))}
      </SimpleGrid>

      <Box>
        <Text fontSize="11px" fontWeight="700" color="#004a33" mb="4px">
          Outra quantidade
        </Text>
        <Input
          type="text"
          inputMode="numeric"
          placeholder="Ex: 120"
          value={answers.peopleMode === "custom" ? answers.people ?? "" : ""}
          onChange={handleCustomChange}
          bg="white"
          border="1.5px solid rgba(0,74,51,0.2)"
          borderRadius="10px"
          h="36px"
          maxW="160px"
          fontSize="13px"
          fontWeight="700"
          color="#004a33"
          _focus={{ borderColor: "#004a33", boxShadow: "none" }}
        />
      </Box>
    </Box>
  );
}
